export default `p=1.-abs(abs(p+sin(p))-1.);
    p=p.x < p.y?p.zxy:p.zyx;
    float s=5., l;
    for(int j=0;j++<4;)
      s*=l=2./min(dot(p,p),1.5),
      p=abs(p)*l-vec3(2.0,1.0,3.0);
    return length(p.yz)/s;
  }`